import { ChakraProvider, extendTheme } from "@chakra-ui/react";

import colors from "core/resources/theme/colors";

const theme = extendTheme({
  fonts: {
    heading: "SuperMoodsRegular, Calibri, sans-serif",
    body: "Calibri, sans-serif",
    mono: "Menlo, monospace",
  },
  components: {
    Text: {
      baseStyle: {
        fontFamily: "Calibri, sans-serif",
        fontSize: [12, 12, 14, 14, 14],
        color: colors.gray600,
      },
    },

    Button: {
      baseStyle: {
        fontFamily: "Calibri, sans-serif",
        fontSize: [12, 12, 14, 14, 14],
        color: colors.gray600,
      },
    },
    Box: {
      baseStyle: {
        fontFamily: "Calibri, sans-serif",
        fontSize: [12, 12, 14, 14, 14],
        color: colors.gray600,
      },
    },
    Input: {
      baseStyle: {
        field: {
          fontFamily: "Calibri, sans-serif",
          fontSize: [12, 12, 14, 14, 14],
          color: colors.gray600,
        },
      },
    },
    Textarea: {
      baseStyle: {
        fontFamily: "Calibri, sans-serif",
        fontSize: [12, 12, 14, 14, 14],
        color: colors.gray600,
      },
    },
    Select: {
      baseStyle: {
        field: {
          fontFamily: "Calibri, sans-serif",
          fontSize: [12, 12, 14, 14, 14],
          color: colors.gray600,
        },
      },
    },
    Radio: {
      baseStyle: {
        label: {
          fontFamily: "Calibri, sans-serif",
          fontSize: [12, 12, 14, 14, 14],
          color: colors.gray600,
        },
      },
    },
    Checkbox: {
      baseStyle: {
        label: {
          fontFamily: "Calibri, sans-serif",
          fontSize: [12, 12, 14, 14, 14],
          color: colors.gray600,
        },
      },
    },
    Switch: {
      baseStyle: {
        label: {
          fontFamily: "Calibri, sans-serif",
          fontSize: [12, 12, 14, 14, 14],
          color: colors.gray600,
        },
      },
    },
    Form: {
      baseStyle: {
        fontFamily: "Calibri, sans-serif",
        fontSize: [12, 12, 14, 14, 14],
        color: colors.gray600,
      },
    },
    FormLabel: {
      baseStyle: {
        fontFamily: "Calibri, sans-serif",
        fontSize: [12, 12, 14, 14, 14],
        color: colors.gray600,
      },
    },
    FormControl: {
      baseStyle: {
        fontFamily: "Calibri, sans-serif",
        fontSize: [12, 12, 14, 14, 14],
        color: colors.gray600,
      },
    },
    FormHelperText: {
      baseStyle: {
        fontFamily: "Calibri, sans-serif",
        fontSize: [12, 12, 14, 14, 14],
        color: colors.gray600,
      },
    },
    FormErrorMessage: {
      baseStyle: {
        fontFamily: "Calibri, sans-serif",
        fontSize: [12, 12, 14, 14, 14],
        color: colors.red,
      },
    },
    Heading: {
      baseStyle: {
        color: colors.gray600,
      },
      variants: {
        superMoodRegular: {
          fontFamily: "SuperMoodsRegular, sans-serif",
        },
        superCellMagic: {
          fontFamily: "SuperCellMagic, sans-serif",
        },
        calibri: {
          fontFamily: "Calibri, sans-serif",
        },
      },
      defaultProps: {
        size: "md",
        variant: "superMoodRegular",
      },
    },
  },

  colors: {},
});

function ChakraUiProvider({ children }: any) {
  return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
}

export default ChakraUiProvider;
